// extracted by mini-css-extract-plugin
module.exports = {"icon":"CreateMenu_icon__HMjzd","link":"CreateMenu_link__1xIa4"};